export const publishDraft = `mutation ($model: PublishDraftRequest!) {
    publishDraft(input: $model){
      kmatID,        
      modVer
     }
  }`;
